import { createAsyncThunk } from '@reduxjs/toolkit';
import { DashboardRepositoryImpl } from '../Data/repositories/DashboardRepositoryImpl';
import { GetDashboardSummaryUseCase } from '../Domain/UseCase/GetDashboardSummaryUseCase';
import { GetDashboardNoticesUseCase } from '../Domain/UseCase/GetDashboardNoticesUseCase';

const repo = new DashboardRepositoryImpl();

export const fetchDashboard = createAsyncThunk('dashboard/fetch', () =>
  new GetDashboardSummaryUseCase(repo).execute(),
);

export const fetchDashboardNotices = createAsyncThunk('dashboard/notices', () =>
  new GetDashboardNoticesUseCase(repo).execute(),
);
